import { useState, useEffect } from "react";

export function useParticipantLayout(participantsCount: number) {
  const [layout, setLayout] = useState<string>("");

  useEffect(() => {
    switch (participantsCount) {
      case 1:
        setLayout("");
        break;
      case 2:
        setLayout("two");
        break;
      case 3:
      case 4:
        setLayout("four");
        break;
      case 5:
      case 6:
        setLayout("six");
        break;
      case 7:
      case 8:
      default:
        setLayout("eight");
        break;
    }
  }, [participantsCount])

  return layout;
}